import {Component} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {Router} from '@angular/router';
import {environment} from './../environments/environment';
import {AbstractSessionService} from './session/abstract-session.service';
import {AppState} from './appState/appStateStore.module';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'OHA' + environment.envName;
  aokName = '';
  aokHref = '';
  aokImpressumHref = '';
  aokDatenschutzHref = '';
  aokDatenschutzRechteHref = '';
  aokLogo = 'logo_aok.jpg';
  aokMail = '';
  currentEnvironment ='';

  timeout$: Observable<number>;
  loggedIn$: Observable<boolean>;
  appVersion: string;

  constructor(private store: Store<AppState>, private sessionService: AbstractSessionService,
              private router: Router) {

    if (!environment.production) {
      this.title += ' (' + environment.envName + ')';
    }

    this.aokName = environment.customizingAok.Name;
    this.aokHref = environment.customizingAok.Href;
    this.aokImpressumHref = environment.customizingAok.ImpressumHref;
    this.aokDatenschutzHref = environment.customizingAok.DatenschutzHref;
    this.aokDatenschutzRechteHref = environment.customizingAok.DatenschutzRechteHref;
    this.aokLogo = environment.customizingAok.Logo;
    this.aokMail = environment.customizingAok.OhaServiceMail;

    this.timeout$ = this.store.select(s => s.app.session.sessionTimeout);
    this.loggedIn$ = this.store.select(s => s.app.session.isIdleRunning);

    sessionService.getVersion().subscribe(response => {
      this.appVersion = response;
    });

    if (environment.envName.includes('qs')) {
      this.currentEnvironment = '[QS]';
    } else if (environment.envName.includes('local') || environment.envName.includes('dev')) {
      this.currentEnvironment = '[DEV]';
    } else {
      this.currentEnvironment = '';
    }

    // loggedOut$ = this.store.select(state => state.userWasUpdated) // this will only trigger when the value changed, because ngrxStore.select has a built-in distinctUntilChanged()
    // .filter(wasUpdated => wasUpdated)
  }

  abmelden() {
    this.sessionService.logout();
    return false; // damit href="#" funktioniert
  }

  changePassword() {
    this.router.navigate(['/changepassword']);
    return false; // damit href="#" funktioniert
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts